export default "__VITE_ASSET__CkfRn6UE__"